import clsx from 'clsx'
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { useLayout } from '../../../core/LayoutProvider'
import { usePageData } from '../../../core/PageData'
import { KTSVG, toAbsoluteUrl } from '../../../../helpers'

const DefaultTitle: FC = () => {
  const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData()
  const { config, classes } = useLayout()
  return (
    <div
      className='d-flex align-items-center'
    >
      <a href="/dashboard">
        <img alt="Logo" src={toAbsoluteUrl(`/media/icons/duotune/house-door.svg`)} className="me-2" style={{ width: "26px", height: "26px" }} />
      </a>
      <p className='text-dark fw-semibold fs-4' style={{ marginTop: "3px" }}>
        {pageTitle}
      </p>

    </div>
  )
}

export { DefaultTitle }
